import { AdressModel } from './adress.model';
import { BankAccountModel } from './bank-account.model';
import { MediaModel } from './media.model';
import { LanguageModel } from './language.model';
import { TerritoryModel } from './territory.model';
import { ThirdPartyModuleModel } from './third-party-module.model';

export class ThirdPartyModel {
  public id: number = null;
  public companyOrPersonName = '';
  public code: string = null;
  public corelId: number = null;
  public idMaster: string = null;
  public clientOrProviderCategory: string = null;
  public thirdPartyType: string = null;
  public thirdPartyCPType: string = null;
  public poThirdPartyCPType: string = null;
  public tel: string = null;
  public fax: string = null;
  public buyingBlocked: boolean;
  public sellingBlocked: boolean;
  public firstName: string = null;
  public address: AdressModel = null;
  public addresses: AdressModel[];
  public thirdPartyModules: ThirdPartyModuleModel[];
  public blocked: boolean;
  public bankAccount: BankAccountModel = null;
  public companyName1: string = null;
  public companyName2: string = null;
  public siret: string = null;
  public siren: string = null;
  public codeSap: string = null;
  public name: string = null;
  public managingTerritory: TerritoryModel = new TerritoryModel();
  public managingMedia: MediaModel = new MediaModel();
  public managingLanguage: LanguageModel = new LanguageModel();
  public versionTimeStamp: string;

  public addressesToDelete: AdressModel[];
  public tpModulesToDelete: ThirdPartyModuleModel[];

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
